import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Flip } from "gsap/Flip";

let SplitText;
try {
  // SplitText ships free with GSAP 3.13+
  // eslint-disable-next-line global-require
  SplitText = require("gsap/SplitText").SplitText;
  gsap.registerPlugin(SplitText);
} catch (e) {
  SplitText = null;
}

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Flip);

export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export { gsap, ScrollTrigger, ScrollToPlugin, Flip, SplitText };
